<script setup lang="ts">
import { cn } from '~~/lib/tw-utils'
import { TooltipContent, type TooltipContentEmits, type TooltipContentProps, TooltipPortal, useForwardPropsEmits } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

defineOptions({
  inheritAttrs: false,
})

const props = withDefaults(defineProps<TooltipContentProps & { class?: HTMLAttributes['class'] }>(), {
  sideOffset: 4,
})

const emits = defineEmits<TooltipContentEmits>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
const attrs = useAttrs()
const combinedPropsAndAttrs = computed(() => {
  return { ...forwarded.value, ...attrs }
})
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
}
</script>
<template>
  <TooltipPortal>
    <TooltipContent
      v-bind="combinedPropsAndAttrs"
      :class="
        cn(
          'z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]_animate-out data-[state=closed]_fade-out-0 data-[state=closed]_zoom-out-95 data-[side=bottom]_slide-in-from-top-2 data-[side=left]_slide-in-from-right-2 data-[side=right]_slide-in-from-left-2 data-[side=top]_slide-in-from-bottom-2',
          props.class,
        )
      "
    >
      <slot />
    </TooltipContent>
  </TooltipPortal>
</template>
